import type { TeamMember } from '../types/content';

export const managingDirector: TeamMember = {
  name: 'Obokeng Rabai',
  position: 'Managing Director',
  qualification: 'B.Eng (Civil), Civil Engineer. Carleton University, Ottawa, Canada (2006)',
  experience: '18 years',
  nationality: 'Motswana',
};

export const teamMembers: TeamMember[] = [
  {
    name: 'Israel Chakanyuka',
    position: 'Project Manager',
    qualification: 'B.Eng Civil / Structural Engineer. University of Zimbabwe (1996)',
    experience: '26 years',
    nationality: 'Motswana',
  },
  {
    name: 'Geoffrey Koodirile',
    position: 'Project Manager',
    qualification: 'B.Eng Environmental Engineering. Carleton University, Ottawa, Canada (2006)',
    experience: '18 years',
    nationality: 'Motswana',
  },
  {
    name: 'Wedu Mabedza',
    position: 'Site Manager',
    qualification: 'B.Eng Civil Engineer. University of Botswana',
    experience: '28 years',
    nationality: 'Motswana',
  },
  {
    name: 'Kabelo Molaodi',
    position: 'Site Manager',
    qualification: 'HND Building and Civils. Nelson Mandela Metropolitan University (2006)',
    experience: '18 years',
    nationality: 'Motswana',
  },
  {
    name: 'Baboloki Obuseng',
    position: 'Site Manager',
    qualification: 'HND Civils. Nelson Mandela Metropolitan University (2006)',
    experience: '18 years',
    nationality: 'Motswana',
  },
  {
    name: 'Utwanang Tshukudu',
    position: 'Site Manager',
    qualification: 'Diploma in Water Engineering. University of Botswana',
    experience: '5 years',
    nationality: 'Motswana',
  },
  {
    name: 'Madibela Manake',
    position: 'Site Foreman',
    qualification: 'Diploma in Highway Engineering',
    experience: '16 years',
    nationality: 'Motswana',
  },
  {
    name: 'Neo Montwedi',
    position: 'SHE Officer',
    qualification: 'Diploma in SHE',
    experience: '8 years',
    nationality: 'Motswana',
  },
  {
    name: 'Keitumetse Kenosi',
    position: 'Accountant',
    qualification: 'Diploma in AAT',
    experience: '24 years',
    nationality: 'Motswana',
  },
  {
    name: 'Warona Rabai',
    position: 'Accounts',
    qualification: 'Diploma in AAT',
    experience: '12 years',
    nationality: 'Motswana',
  },
];
